import React, { useEffect, useState } from 'react';

export default function LeaderboardPage() {
  const [totals, setTotals] = useState([]);
  const [error, setError] = useState(null);

  const backendBase =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    (window.location.hostname === 'localhost'
      ? 'http://localhost:5001'
      : 'https://pickem-backend-2025.onrender.com');

  useEffect(() => {
    fetch(`${backendBase}/api/totals`, { cache: 'no-store' })
      .then(res => {
        if (!res.ok) throw new Error('Totals not available');
        return res.json();
      })
      .then(data => {
        const sorted = [...data].sort((a, b) => b.total - a.total);
        setTotals(sorted);
      })
      .catch(() => setError('Leaderboard data not available yet.'));
  }, [backendBase]);

  return (
    <div className="page-container">
      <h2>🏆 Leaderboard</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {!error && totals.length > 0 && (
        <table style={{
          width: '100%', borderCollapse: 'collapse', marginTop: 20, backgroundColor: '#fdfdfd',
          borderRadius: 8, overflow: 'hidden', boxShadow: '0 0 10px rgba(0,0,0,0.05)'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f0f0f0', fontWeight: 'bold' }}>
              <th style={{ padding: 12, textAlign: 'left' }}>Game Name</th>
              <th style={{ padding: 12, textAlign: 'left' }}>Cumulative Points</th>
            </tr>
          </thead>
          <tbody>
            {totals.map((p, idx) => (
              <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                <td style={{ padding: 10 }}>{p.player}</td>
                <td style={{ padding: 10 }}>{p.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
